import styled from "styled-components";

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ align }) => align || "space-between"};
  > div,
  > a,
  > select,
  > button {
    :first-child {
      margin: 10px 0 10px 0;
    }
    :last-child {
      margin: 10px 0 10px 0;
    }
  }
  @media (min-width: 600px) {
    flex-direction: row;
    > div,
    > a,
    > select,
    > button {
      :first-child {
        margin: 20px 10px 20px 0;
      }
      :last-child {
        margin: 20px 0 20px 10px;
      }
    }
  }
  ${({ css }) => css}
`;

export default ButtonsWrapper;
